<script setup lang="ts">
import { computed, ref, type Ref, nextTick } from 'vue'
import { setName, type Name, saveUserInfo, lastInvitation } from '@/composables/user/users'
import { CODE_OK } from '@/apis/code'
import { handleErr } from '@/composables/exception/handler'
import { ElMessage } from 'element-plus'
import { renderMessage } from '@/utils/util'
import type { CommonResponse } from '@/apis/api'
import { useRouter } from 'vue-router'
import { OPEN_URL_INVITATION } from '@/constants'
import { useI18n } from 'vue-i18n'
import { isEmpty } from '@/utils/util'
import { isNotEmpty } from '@/utils/util'
import { redirectUrl } from '@/utils/routerShim'
import { ElDialog } from 'element-plus'
import { loginDialogTitle, loginDialogCanClose } from '@/composables/user/users'
import logo from '@/assets/logo_svg.svg'

let fullName: Ref<string> = ref('')

const { t } = useI18n()

const router = useRouter()

const dialogWidth = computed(() => {
  if (typeof window === 'undefined') {
    return '370px'
  }
  return window.innerWidth <= 768 ? '85%' : '370px'
})

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})
const showRedirectToLoginDialog = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
const emit = defineEmits(['update:modelValue'])

const handleLogin = () => {
  redirectUrl.value = router.currentRoute.value.fullPath
  router.replace('/login').then(() => {
    // 清空历史记录
    window.history.replaceState(null, '', window.location.href)
  })
  showRedirectToLoginDialog.value = false
}

const handleClose = () => {
  nextTick(() => {
    loginDialogCanClose.value = true
    loginDialogTitle.value = ''
  })
}
</script>
<template>
  <el-dialog
    @closed="handleClose"
    v-model="showRedirectToLoginDialog"
    :width="dialogWidth"
    align-center
    :show-close="loginDialogCanClose"
    :title="null"
    class="no-header-dialog"
    :close-on-click-modal="loginDialogCanClose"
    :close-on-press-escape="loginDialogCanClose">
    <div w-full p-2 class="max-w-md">
      <div flex items-center justify-start>
        <img :src="logo" w-10 h-10 alt="logo" />
        <div text-xl text-main ml-3>{{ $t('app.name') }}</div>
      </div>
      <div mt-6 text-lg>{{ loginDialogTitle ? loginDialogTitle : $t('open_life.please_login_to_continue') }}</div>
      <div flex items-center mt-7 gap-3 justify-center>
        <div
          v-if="loginDialogCanClose"
          text-base
          text-main
          cursor-pointer
          @click="showRedirectToLoginDialog = false"
          btn-outline
          rounded-2
          px-4
          py-3
          flex-1
          text-center>
          {{ $t('action.not_login') }}
        </div>
        <div text-base text-white cursor-pointer @click="handleLogin" btn-solid rounded-2 px-4 py-3 flex-1 text-center>
          {{ $t('action.to_login') }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped>
.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>

<style>
.no-header-dialog .el-dialog__header {
  display: none !important;
}
</style>
